import { createTheme } from "@mui/material";
import { rootTheme } from "../../utils/theme";

export const gettingStartedTheme = createTheme({
  typography: {
    ...rootTheme.typography,
  },
});

export const theme = createTheme({
  typography: {
    ...rootTheme.typography,
  },
  components: {
    MuiDivider: {
      styleOverrides: {
        root: {
          marginLeft: 0,
          marginRight: 0,
          marginTop: 30,
          width: "100%",
          marginBottom: 20,
          color: "#0088F5",
          backgroundColor: "#0088F5",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: "#F8FAFF",
        },
        subtitle1: {
          fontWeight: 700,
          fontSize: 16,
          textAlign: "center",
        },
        subtitle2: {
          fontWeight: 400,
          fontSize: 14,
          textAlign: "center",
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "#737373",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          color: "#F8FAFF",
          height: "40px",
          padding: "8px 0px",
          border: "1px solid #404040",
          outlineWidth: "1px",
          background: "#041939",
          fontSize: 14,
          paddingRight: 2,
          // border: "1px solid rgba(0, 136, 245, 0.7);",
          width: "100%",
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: "#F8FAFF",
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          marginTop: 35,
          color: "#F8FAFF",
        },
      },
    },
  },
});

export const styles = {
  logo: {
    width: 100,
  },
  form: {
    width: "100%",
  },
  logoContainer: {},
};
